export default "__VITE_ASSET__BXxcxj4Q__"